import { render, staticRenderFns } from "./DescriptionEvent.vue?vue&type=template&id=c07e722a"
import script from "./DescriptionEvent.vue?vue&type=script&lang=js"
export * from "./DescriptionEvent.vue?vue&type=script&lang=js"
import style0 from "./DescriptionEvent.vue?vue&type=style&index=0&id=c07e722a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports